import { render, staticRenderFns } from "./contractDebitosMuncipais.vue?vue&type=template&id=0f3e11d9&"
import script from "./contractDebitosMuncipais.vue?vue&type=script&lang=js&"
export * from "./contractDebitosMuncipais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports